import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=47ec1d08&scoped=true&"
import script from "./logo.vue?vue&type=script&lang=js&"
export * from "./logo.vue?vue&type=script&lang=js&"
import style0 from "./logo.vue?vue&type=style&index=0&id=47ec1d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec1d08",
  null
  
)

export default component.exports